module.exports = __webpack_public_path__ + "static/media/bottomsheet_verify_email.2098001d.svg";